module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.ac3f799d.ttf";